import BasicModal from "@/components/basic-modal";
import Alert from "@mui/material/Alert";

const AppointmentDeleteModal = ({
  selected = {},
  open,
  onClose,
  onDelete,
  loading = false,
}) => {
  return (
    <BasicModal
      open={open}
      size="sm"
      title={"Delete Appointment"}
      handleClose={onClose}
      saveButtonTitle={"Delete"}
      saveCallback={onDelete}
      saveBtnDisabled={loading}
      saveBtnLoading={loading}
      modalBodySx={{ padding: "1rem" }}
    >
      <Alert
        severity={"error"}
      >{`Do you want to delete appointment ${selected?.title}`}</Alert>
    </BasicModal>
  );
};

export default AppointmentDeleteModal;
